import {DragHandlerBase} from '../Handler/drag-handler-base';

declare let THREE: any;

export class DragBehaviorBase extends DragHandlerBase {

  constructor(rootHandler: DragHandlerBase) {
    super(rootHandler);
  }

  canExecute(objects: Array<any>): boolean {
    return true;
  }

  getStaticObjectsFilter(objects: any[]): (obj) => boolean {
    return function (obj) {
      return obj.visible &&
        obj.userData.entity &&
        objects.indexOf(obj) === -1;
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Behavior/drag-behavior-base.ts